import styles from "../PaceLandingLayout.styles";

// Material UI components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { List, ListItem } from "@mui/material";

// Components
import CustomIcon from "components/CustomIcon";
import PaceHeader from "components/Pace/PaceHeader";
import HorizontalBox from "./HorizontalBox";

// Others
import { FormattedMessage } from "react-intl";
import icons from "enums/icons";

// Images
import checkListIconBlue from "assets/images/svgs/checklist-icon-blue.svg";
import clockIconBlue from "assets/images/svgs/clock-blue.svg";
import paceColouredLogo from "assets/images/pngs/PACE_Logo_RGB 2.png";

interface IPaceLandingLayoutProps {
    isNewAssessment: boolean;
    handleStartPace: () => void;
}

const ListItems = [
    "pace.welcome.description.listItem1",
    "pace.welcome.description.listItem2",
    "pace.welcome.description.listItem3",
    "pace.welcome.description.listItem4",
];

const PaceLandingLayout = ({ isNewAssessment, handleStartPace }: IPaceLandingLayoutProps): JSX.Element => {
    const classes = styles.paceLandingLayoutStyles();

    return (
        <>
            <Box>
                <PaceHeader title={<FormattedMessage id={"pace.welcome.to"} />} />
                <Box className={classes.boxWrapper}>
                    <Box display="flex" alignItems="center" mb={4}>
                        <Box>
                            <img src={paceColouredLogo} alt="pace-logo" />
                        </Box>
                        <Box ml={8}>
                            <Typography variant="h6" mb={1}>
                                <FormattedMessage id={"pace.welcome.description.title"} />
                            </Typography>
                            <Typography variant="subtitle1" color="secondary.main" mb={1}>
                                <FormattedMessage id={"pace.welcome.description.subtitle"} />
                            </Typography>
                            <Typography variant="body2">
                                <FormattedMessage id={"pace.welcome.description.listDescription"} />
                            </Typography>
                            <List component="ul" disablePadding sx={{ listStyleType: "disc", marginLeft: "30px" }}>
                                {ListItems.map((item, key) => (
                                    <ListItem key={key} component="li" disablePadding sx={{ display: "list-item" }}>
                                        <Typography variant="body2">
                                            <FormattedMessage id={item} />
                                        </Typography>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Box>

                    <Grid container className={classes.aboutSubBoxes}>
                        <Grid item xs={6}>
                            <HorizontalBox
                                image={checkListIconBlue}
                                text={[
                                    <FormattedMessage key="0" id="pace.about.box.1A" />,
                                    <FormattedMessage key="1" id="pace.about.box.1B" />,
                                ]}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <HorizontalBox
                                image={clockIconBlue}
                                text={[
                                    <FormattedMessage key="0" id="pace.about.box.2A" />,
                                    <FormattedMessage key="1" id="pace.about.box.2B" />,
                                ]}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        variant="contained"
                        className={classes.startPaceButton}
                        endIcon={<CustomIcon type="outlined" icon={icons.chevronRightThin} />}
                        onClick={handleStartPace}
                    >
                        <FormattedMessage id={`${isNewAssessment ? "pace.lets.start" : "pace.resume.assessment"}`} />
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default PaceLandingLayout;
